import { CredentialModel } from './credential.model';

export class CameraModel {
  Id?: number;
  Name?: string;
  SiteId?: number;
  Description?: string;
  IpAddress: string;
  Resolution: string;
  CredentialId?: number;
  AcsId?: string;
  ViewId?: number;
  MacAddress?: string;
  Capabilities?: number;
  CameraType?: CameraType;
  Model?: string;
  LastSync?: Date;
  ServiceDate?: Date;

  Credential?: CredentialModel;

  // UI properties
  HasError?: boolean;
  ErrorMessage?: string;
}

export enum CameraType {
  Normal = 0,
  Panoramic = 1,
  Thermal = 2,
  Furnace = 3,
}
